import React, { useState, useEffect } from 'react';
import api from '../../api/client';
import { useToast, Button } from '../ds';
import { CDN } from '../../config/cdn';
import './PlacementCode.css';

function generateSimpleCode(ad, appName) {
  const { placement_uuid, application_id, placement_type, name, placement_name } = ad;
  const placementLabel = placement_name || (name + ' Placement');
  return `<!--
Publisher : ${appName}
Placement : ${placementLabel}
Version : 4.20_patch_version
-->
<script id="vm5ad-js-sdk" src="https://vawpro.vm5apis.com/man.js" data-mode="fast"></script>
<script>
  window.onVM5AdLiteReady = function() {
    VM5AdLite.init({ appKey: '${application_id}' });
  };
</script>
<script src="${CDN.AD_LITE}"></script>
<vmfive-ad-unit style='display: block; max-width: 100vw; width: 100%; margin: auto;' app-patch="${CDN.appPatch(application_id, placement_type)}" placement-patch="${CDN.placementPatch(placement_uuid)}" placement-id='${placement_uuid}' type='${placement_type}'></vmfive-ad-unit>`;
}

function generateGAMCode(ad, appName) {
  const { placement_uuid, application_id, placement_type, name, placement_name } = ad;
  const placementLabel = placement_name || (name + ' Placement');
  return `<!--
Publisher : ${appName}
Placement : ${placementLabel}
Version : 4.20_patch_version
-->
  <!DOCTYPE html>
  <html>
  <head>
    <meta charset="UTF-8" />
    <title>Friendly iframe</title>
  </head>
  <body>
  <img src="https://pt0.vm5apis.com/api/v2/pixel?provider=GAM&event=placement_landing&eventDetails=%7B%22placementId%22%3A%20%22${placement_uuid}%22%7D" style="display:none;">
  <script>
    const GOOGLE_ADS_IFRAME_PREFIX = 'google_ads_iframe_';
    var creativeID = parseInt("%ecid!"),
      gamSlotWidth = parseInt("%%WIDTH%%"),
      gamSlotHeight = parseInt("%%HEIGHT%%"),
      isRender = false,
      gamSlotElementID,
      slotEl = null;

    if (!isRender) {
      var currentWindow = window;
      while (!isInCrossOriginIFrame(currentWindow) && currentWindow != currentWindow.parent) {
        var outerSlotEl = getOuterGamSlotEl(currentWindow);
        if (outerSlotEl) {
          console.log("[vmfive] born from", outerSlotEl.id);
          slotEl = outerSlotEl;
        } else {
          slotEl = currentWindow.frameElement;
        }

        currentWindow = currentWindow.parent;
      }

      if (isInCrossOriginIFrame(currentWindow)) {
        console.log("[vmfive] this creative is in a cross-origin iframe");
      }

      let adUnitFromSameAdUnit = currentWindow.document.querySelector("vmfive-ad-unit[gam-slot='"+gamSlotElementID+"']");
      if (adUnitFromSameAdUnit) {
        console.log('[vmfive] got ad unit with same gam slot element id', gamSlotElementID, 'skip this request');
      } else {
        if (slotEl == null) {
          console.log("[vmfive] can't find outer GAM slot, append in this window");
        }

        createManJsAnchor(currentWindow.document, slotEl);
        createAdUnit(currentWindow.document, slotEl);
        loadScripts(currentWindow.document);
        registerSDKReadyCallback(currentWindow);
      }

      isRender = true;
      if (slotEl) {
        slotEl.style.display = "none";
      }
    }

    function isInCrossOriginIFrame(currentWindow) {
      try {
        return !('null' === currentWindow.location.origin || currentWindow.location.origin == currentWindow.parent.location.origin);
      } catch (error) {
        return true;
      }
    }

    function getOuterGamSlotEl(currentWindow) {
      var slotEl = null;
      var currentWindowName = currentWindow.name.indexOf(GOOGLE_ADS_IFRAME_PREFIX) == 0 ? currentWindow.name.substr(GOOGLE_ADS_IFRAME_PREFIX.length) : currentWindow.name;
      try {
        currentWindow.parent.googletag.pubads().getSlots().some(function(slot) {
          if(slot) {
            if (slot.getSlotId().getId() === currentWindowName) {
              slot.setCollapseEmptyDiv(true, true);
              gamSlotElementID = slot.getSlotId().getDomId();
              slotEl = currentWindow.parent.document.getElementById(currentWindow.name).closest('[id^=' + gamSlotElementID + ']');
            }
          }
        });
      } catch (error) {
      }

      return slotEl;
    }

    function createManJsAnchor(document, el) {
      var anchor = document.createElement('div');
      anchor.id = 'vm5ad-js-sdk';
      anchor.setAttribute('data-mode', 'fast');
      if (el) {
        el.parentNode.insertBefore(anchor, el);
      } else {
        document.body.appendChild(anchor);
      }
    }

    function createAdUnit(document, el) {
      var adUnit = document.createElement('vmfive-ad-unit');
      adUnit.setAttribute('placement-id', '${placement_uuid}');
      adUnit.setAttribute('type', '${placement_type}');
      adUnit.setAttribute('app-patch', '${CDN.appPatch(application_id, placement_type)}');
      adUnit.setAttribute('placement-patch', '${CDN.placementPatch(placement_uuid)}');
      adUnit.setAttribute('dfp-url', '%%CLICK_URL_UNESC%%');
      adUnit.setAttribute('gam-url', '%%CLICK_URL_UNESC%%');
      adUnit.setAttribute('dfp-slot', gamSlotElementID);
      adUnit.setAttribute('gam-slot', gamSlotElementID);
      adUnit.style.display = "block";
      adUnit.style.maxWidth = "100vw";
      adUnit.style.width = "100%";
      adUnit.style.margin = "auto";
      if (el) {
        el.parentNode.insertBefore(adUnit, el);
      } else {
        document.body.appendChild(adUnit);
      }
    }

    function loadScripts(document) {
      [
        "https://vawpro.vm5apis.com/man.js",
        "${CDN.AD_LITE}"
      ].forEach(function(src) {
        var script = document.createElement('script');
        script.src = src;
        script.async = false;
        document.head.appendChild(script);
      });
    }

    function registerSDKReadyCallback(win) {
      win.onVM5AdLiteReady = function() {
        win.VM5AdLite.init({ appKey: '${application_id}' });
      };
    }
  </script>
  </body>
  </html>`;
}

export default function PlacementCode({ ad, integrationType }) {
  const [appName, setAppName] = useState('');
  const { addToast } = useToast();

  useEffect(() => {
    if (!ad.application_id) return;
    const companyId = sessionStorage.getItem('portal_company_id');
    if (!companyId) return;
    api.getPortalApplications(companyId).then((apps) => {
      const match = (apps || []).find((a) => a.uuid === ad.application_id);
      if (match) setAppName(match.app_name);
    }).catch(() => {});
  }, [ad.application_id]);

  const code = integrationType === 'gam' ? generateGAMCode(ad, appName) : generateSimpleCode(ad, appName);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(code);
      addToast('代碼已複製', 'success');
    } catch {
      addToast('複製失敗，請手動複製', 'error');
    }
  };

  return (
    <div className="detail-section">
      <div className="detail-section__title">廣告代碼</div>
      <div className="placement-code">
        <div className="placement-code__block">
          <pre><code>{code}</code></pre>
        </div>
        <div className="placement-code__actions">
          <Button size="sm" onClick={handleCopy}>複製代碼</Button>
        </div>
      </div>
    </div>
  );
}
